<div class="text-area-input-container">
  @if (label && labelType !== labelTypeOptions.PLACEHOLDER) { @if (labelType === labelTypeOptions.STATIC) {
  <div class="d-flex gap-1 align-items-center">
    <ng-container [ngTemplateOutlet]="labelTemplate"></ng-container>
    @if (inputLabelTooltipText?.length) {
    <finxone-platform-tooltip
      [content]="inputLabelTooltipText"
      [textStyleClass]="tooltipTextStyleClass"
      [borderRadiusClass]="tooltipBorderRadiusClass"
    ></finxone-platform-tooltip>
    }
  </div>
  } @else {
  <ng-container [ngTemplateOutlet]="labelTemplate"></ng-container>
  } }

  <div #textAreaElementWrapper class="input-wrapper position-relative">
    <!-- Prefix Content -->
    <ng-content select="[prefix]"></ng-content>
    <!-- Custom Template or Default Text area -->
    <ng-container
      *ngIf="customInputTemplate; else defaultTextArea"
      [ngTemplateOutlet]="customInputTemplate"
      [ngTemplateOutletContext]="{
        $implicit: {
          value: value,
          control: control,
          onInput: onInputChange.bind(this),
          onBlur: onTouched.bind(this),
          onFocus: onTouched.bind(this)
        }
      }"
    ></ng-container>
    <!-- Suffix Content -->
    <ng-content select="[suffix]"></ng-content>
  </div>
  <div *ngIf="showErrors && control?.invalid && control?.touched" class="error-container" role="alert">
    <div class="is-vertical-align mt-1">
      @for (error of control.errors | keyvalue; track error.key) {
      <small class="typog-xs text-error">
        {{ getErrorMessageBasedOnKey(error) }}
      </small>
      }
    </div>

    <!-- Custom Error Template -->
    <ng-container
      *ngIf="customErrorTemplate"
      [ngTemplateOutlet]="customErrorTemplate"
      [ngTemplateOutletContext]="{
        $implicit: {
          control: control,
          errors: control?.errors
        }
      }"
    ></ng-container>
  </div>
</div>

<ng-template #defaultTextArea>
  <textarea
    hlmInput
    [formControl]="control"
    [id]="id"
    [name]="name"
    [autocomplete]="disableAutocomplete ? 'nope' : undefined"
    [value]="value"
    [placeholder]="
      labelType === labelTypeOptions.PLACEHOLDER
        ? label
        : labelType === labelTypeOptions.FLOATING
        ? ''
        : placeholder
    "
    [readonly]="readOnly"
    (input)="onInputChange($event)"
    (blur)="onTouched(); isInputOnFocus = false"
    (focus)="isInputOnFocus = true"
    [class]="textStylingClass + ' ' + borderRadiusClass + ' ' + 'inputTextArea'"
    [ngClass]="{ 'pl-7': hasPrefixContent }"
  ></textarea>

  <!-- Info  Template -->
  <ng-container *ngIf="infoText">
    <div [innerHTML]="infoText | safeHtml"></div>
  </ng-container>
</ng-template>

<ng-template #labelTemplate>
  <label
    [class.labelActive]="isInputOnFocus"
    [class.floatingLabelWithValue]="control?.value?.length && labelType === labelTypeOptions.FLOATING"
    [class.floatingLabel]="labelType === labelTypeOptions.FLOATING"
    class="labelText labelIdle labelConfig"
    [for]="name"
    (click)="handleLabelClick()"
    >{{ label }}</label
  >
</ng-template>
